import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { initAttribution, recordPage, getAttribution, getSessionId, trackEvent } from '../lib/attribution';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const placementFor = (el) => {
  const tagged = el.closest('[data-testid]');
  const region = el.closest('header, footer, aside, nav, section');
  return (tagged?.getAttribute('data-testid') || region?.getAttribute('data-testid') || region?.tagName.toLowerCase() || 'page').slice(0, 80);
};

// Records first-touch attribution, pages visited and click-to-call taps (no personal data)
export const SiteTracking = () => {
  const { pathname } = useLocation();

  useEffect(() => { initAttribution(); }, []);
  useEffect(() => { recordPage(pathname); }, [pathname]);

  useEffect(() => {
    const onClick = (e) => {
      const link = e.target.closest?.('a[href^="tel:"]');
      if (!link) return;
      const placement = placementFor(link);
      trackEvent('click_to_call', { page_path: window.location.pathname, link_location: placement });
      axios.post(`${BACKEND_URL}/api/track/call-click`, {
        session_id: getSessionId(),
        page: window.location.pathname,
        placement,
        attribution: getAttribution(),
      }).catch(() => {});
    };
    document.addEventListener('click', onClick, true);
    return () => document.removeEventListener('click', onClick, true);
  }, []);

  return null;
};
